<template>
  <div class="short-video-item" v-if="itemData" @click="onTap">
    <div class="left-box">
      <div class="imager g-cover">
        <div class="image g-cover"
             :style="'background-image:url(' + coverImage + ')'"
             ></div>
      </div>
      <div class="time" v-if="duration">{{duration}}</div>
    </div>
    <div class="right-box">
      <div class="title g-item-title g-ellipsis-2">{{itemData.title}}</div>
      <div class="desc g-ellipsis">
        <span v-if="formatTime">{{formatTime}}</span><span v-if="formatTime && likeCount"> | </span><span v-if="likeCount">{{likeCount}}个赞</span></div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils/util'
  import detect from '@iqiyi-kpp/utility/es/detector'
  import iqy from '@iqiyi-kpp/utility/es/iqiyi'
  import pv from "@/service/pingback/pv";

  export default {
    props: {
      itemData: {
        type: Object
      },
      storeKey: {
        type: String
      }
    },

    computed: {
      coverImage() {
        if(this.itemData && this.itemData.imageInfo.sourceImageUrl) {
          return utils.getRightPicSize(this.itemData.imageInfo.sourceImageUrl, '480_270');
        }
        return null
      },

      formatTime() {
        if (this.itemData && this.itemData.createTime) {
          const date = new Date(this.itemData.createTime)
          return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        }
        return null
      },

      duration() {
        if (this.itemData && this.itemData.length) {
          return utils.formatDuration(this.itemData.length)
        }
        return null
      },

      likeCount() {
        if (this.itemData && this.itemData.likeCount) {
          if (this.itemData.likeCount >= 10000) {
            const str = (this.itemData.likeCount / 10000).toFixed(1)
            const v = str.split('.')[1]
            if (v === '0') {
              return `${str.split('.')[0]}万`
            }
            return `${str}万`
          }
          return this.itemData.likeCount
        }
        return 0
      }
    },

    methods: {
      onTap() {
        pv.click({
          rpage: `knowledge_h5_shop_${this.storeKey}_小知识`,
          block: "shortvideolist",
          rseat: "click",
          r: this.itemData.qipuId
        });

        if (detect.zhishi()) {
          const version = iqy.getVersion()
          if (version >= 10905) {
            this.$callNative.open({
              schema: 'knowledge',
              type: 'svideo',
              dynamic: `id=${this.itemData.qipuId}&backTab=2`
            })
          } else {
            this.$msgbox.alert({
              desc: '此功能需在爱奇艺知识1.9.5版本以上才能使用哦~，马上升级吧',
              callback() {
                if (detect.iOS()) {
                  this.$callNative.openAppleStore()
                }
              }
            })
          }
        } else {
          if (detect.iqiyi()) {
            const version = iqy.getVersion()
            if (version >= 110300) {
              if (detect.iOS()) {
                this.$callNative.open({
                  schema: 'knowledge',
                  type: 'svideo',
                  dynamic: `id=${this.itemData.qipuId}&backTab=2`
                })
              } else {
                this.$callNative.open({
                  schema: 'plugin',
                  type: 'svideo',
                  dynamic: `id=${this.itemData.qipuId}&backTab=2`
                })
              }
            } else {
              location.href = `//zhishi.m.iqiyi.com/short-video?productId=${this.itemData.qipuId}`
            }
          } else {
            // 站外则跳转到H5短视频页
            location.href = `//zhishi.m.iqiyi.com/short-video?productId=${this.itemData.qipuId}`
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  @import "../../assets/css/func";
  @import "../../assets/css/var";

  .short-video-item {
    width: 100%;
    position: relative;
    display: flex;
    .set(padding-top, 30);
    .set(margin-bottom, 10);

    .left-box {
      position: relative;
      .imager {
        .set(width, 246);
        .set(height, 138);
        background-image: url(//pic2.iqiyipic.com/kppfe/static/image/20190906/placeholder-column.png);
      }
      .image {
        width: 100%;
        height: 100%;
        border-radius: 1.06666667vw;
      }
      .time {
        position: absolute;
        text-align: right;
        bottom: 0;
        width: 100%;
        color: #ffffff;
        .set(height, 50);
        .set(font-size, 22);
        .set(padding-right, 8);
        line-height: 3;
        background-image: linear-gradient(-180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.50) 100%);
        border-radius: 0 0 1.06666667vw 1.06666667vw;
      }
    }

    .right-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      .set(padding-left, 20);

      .g-item-title {
        white-space: inherit;
        text-overflow: inherit;
      }

      .title {
        line-height: 1.3;
      }
      .desc {
        color: @color-description;
        .set(font-size, 24);
        width: 100%;
        margin-top: auto;
        line-height: 1.6;
      }
    }
  }
</style>
